export default __webpack_public_path__ + "static/media/signaturePlaceholder.40353ba2.png";